import Button from "@components/elements/Button";
import SectionTitle from "@components/elements/SectionTitle";
import useSwrHook from "@lib/services/hooks/swr/useSwrHook";
import { useRef } from "react";
import get from "lodash/get";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, EffectCreative, Pagination } from "swiper";
import "swiper/css/effect-creative";
import styles from "./TradeHomeAcademy.module.css";
import Image from "next/image";
import { getStrapiMedia } from "@utils/media";
import useGlobalVariable from "@lib/store/hooks/useGlobalVariables";
import { useStore } from "@lib/store";
import { shallow } from "zustand/shallow";
import NextImage from "@src/components/elements/Image";
import useLocale from "@lib/store/hooks/useLocale";

const TradeHomeAcademy = (props) => {
  const { gv } = useGlobalVariable();
  const locale = useLocale();
  const data = props.data || props;
  const academyHomepageUrl = get(data, "academy_homepage.data.0.slug", "");
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  const store = useStore(
    (store) => ({
      dir: store.direction,
    }),
    shallow
  );

  if (!data) return null;

  const {
    data: academyCategories,
    loading,
    error,
  } = useSwrHook(`academyCategories`, {
    query: {
      populate: {
        video: {
          fields: ["url"],
        },
      },
      fields: ["title", "description", "featured"],
      filters: {
        featured: {
          $eq: true,
        },
      },
      sort: ["id:asc"],
    },
  });

  if (!academyCategories || !academyCategories?.data) return null;
  const categories = [...(academyCategories?.data || [])];
  if (locale === "eu" || locale === "es" || locale === "de") {
    categories.push({
      attributes: {
        title: gv("academy_card_1_title"),
        description: gv("academy_card_1_text"),
        url: "https://capex.com" + gv("academy_card_1_url"),
        video: get(categories, "1.attributes.video", {}),
      },
    });
  }
  return (
    <div className="container">
      <div className="flex w-full flex-col justify-between lg:flex-row">
        <div className={`flex w-full flex-col lg:max-w-[calc(100%/2-1rem)] ${styles.title} pb-xl md:pb-0`}>
          <div className="rounded-3xl bg-[#F5F5F7] px-sm pt-xl pb-[14.37500rem] lg:bg-transparent lg:px-0 lg:pt-0 lg:pb-0">
            <SectionTitle data={data?.section_title} />
          </div>
          <div className="mt-lg hidden lg:block">
            <Button data={data?.button} />
          </div>
        </div>
        <div
          className={`relative  ${styles.shadowContainer} academySlider -mt-[15.37500rem] w-full md:-mt-[12rem] lg:mt-0 lg:max-w-[calc(100%/2-1rem)]`}
        >
          <Swiper
            dir={store ? store.dir : "ltr"}
            modules={[Navigation, EffectCreative, Pagination]}
            navigation={{
              prevEl: navigationPrevRef.current ? navigationPrevRef.current : undefined,
              nextEl: navigationNextRef.current ? navigationNextRef.current : undefined,
            }}
            effect="creative"
            creativeEffect={{
              prev: {
                shadow: false,
                translate: [0, 0, -400],
              },
              next: {
                translate: ["100%", 0, 0],
              },
            }}
            onSwiper={(swiper) => {
              // Delay execution for the refs to be defined
              setTimeout(() => {
                // Override prevEl & nextEl now that refs are defined
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
                // Re-init navigation
                swiper.navigation.destroy();
                swiper.navigation.init();
                swiper.navigation.update();
              });
            }}
            pagination
            spaceBetween={5}
            slidesPerView={1}
            loop
          >
            {categories?.map((category, index) => (
              <SwiperSlide key={index}>
                <div
                  className={`${styles.slideBox} mx-auto flex max-w-[80%] cursor-pointer flex-col items-center px-md py-lg md:max-w-[50%] lg:max-w-[60%] lg:px-xl ltr:lg:mr-xl rtl:lg:ml-xl`}
                >
                  <div className="relative h-[7.883rem] w-[10.777rem]">
                    <NextImage src={category?.attributes?.video} alt={category?.title} />
                    {/* <video muted loop playsInline preload="none" width="230" height="177" style={{ maxWidth: '100%' }}>
                      <source src={getStrapiMedia(category?.attributes?.video?.data?.attributes?.url)} type="video/mp4" />
                      <source src={getStrapiMedia(category?.attributes?.video?.data?.attributes?.url)} type="video/ogg" />
                      Your browser does not support the video tag.
                    </video> */}
                  </div>
                  <div className="pt-md text-center">
                    <p className="pb-0 font-bold">{category?.attributes?.title}</p>
                    <p className={`${styles.description}`}>{category?.attributes?.description}</p>
                    <div className="mt-lg">
                      <Button
                        type="white-darkblue"
                        size="sm"
                        arrow="right"
                        label={gv("learn_more")}
                        link={category?.attributes?.url || academyHomepageUrl}
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="hidden flex-col items-center justify-center lg:flex">
          <div
            ref={navigationPrevRef}
            className={`${styles.animationArrowLeft} mt-[0.5%] cursor-pointer py-xs text-[1.5rem] text-[#777] transition-all duration-300 ltr:ml-0 rtl:mr-0`}
          >
            <NextImage src="https://cdn.capex.com/uploads/nav_icon_left_2102847053/nav_icon_left_2102847053.png" width={45} height={45} alt="nav-icon" />
          </div>
          <div
            ref={navigationNextRef}
            className={`${styles.animationArrowRight} mt-[0.5%] rotate-180 cursor-pointer py-xs text-[1.5rem] text-[#777] transition-all duration-300 ltr:mr-0 rtl:ml-0`}
          >
            <NextImage src="https://cdn.capex.com/uploads/nav_icon_right_f77b699709/nav_icon_right_f77b699709.png" width={45} height={45} alt="nav-icon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradeHomeAcademy;
